/**
 * PR-CWJ-02 — Workflow Orchestrator types
 *
 * gstack-style stage-managed workflow: intake → product review → engineering
 * plan → design/security review → approval → implementation → code review →
 * QA → release evidence → owner approval → retrospective.
 *
 * This module does NOT execute any real agent, tool, or code. It only validates
 * stage transitions, evidence, approvals, skip rules, retry limits, timeouts,
 * and risk escalation, and emits audit events.
 *
 * Workflow-to-task binding is contract-level: every workflow carries a canonical
 * `taskId` and a typed status mapping to `CwjTaskStatus`. Runtime two-way sync is
 * optional and only performed when a `CwjTaskEngine` is injected; drift is
 * fail-closed.
 */
export class CwjWorkflowEngineError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = "CwjWorkflowEngineError";
    }
}
//# sourceMappingURL=types.js.map